import { tableSchema } from '@nozbe/watermelondb';

import type { ITable } from './interface';

export const stepTable = {
  name: 'steps',
  columns: [
    {
      name: 'step_id',
      type: 'number',
    },
    {
      name: 'name',
      type: 'string',
    },
    {
      name: 'order',
      type: 'number',
      isOptional: true,
    },
    {
      name: 'is_quota',
      type: 'boolean',
    },
    {
      name: 'form_id',
      type: 'number',
    },
    {
      name: 'form_version',
      type: 'string',
    },
    {
      name: 'total_questions',
      type: 'number',
    },
    {
      name: 'created_by',
      type: 'string',
    },
    {
      name: 'updated_by',
      type: 'string',
    },
    {
      name: 'created_at',
      type: 'number',
    },
    {
      name: 'updated_at',
      type: 'number',
    },
  ],
} as ITable;

export const stepSchema = tableSchema(stepTable);
